interface IIntegrationSettingsExtension {
    cardSubtitle:string
}

export const SettingsPageExtension: any[] = [];
export const IntegrationSettingsExtension:IIntegrationSettingsExtension = {
    cardSubtitle:'Содержит перечень соединений с JIRA, Active Directory и Почтовой системой'
}